import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { getGemEnableFiltersList, insertFilter, getMinistryList, getOrganizationList } from "../../Redux/Gem/Action";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import NewDataTable from "../DataTable/NewDataTable";
import { format } from "date-fns";
import Select from 'react-select';


const GemEnableFilter = () => {

    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const { gemenalbefilterlist, ministrylist, organizationlist } = useSelector((store) => store.gem);
    const [show, setShow] = useState(false);

    const [gemFilterData, setGemFilterData] = useState({
        ministryId: "",
        organizationId: "",
    });

    useEffect(() => {
        dispatch(getGemEnableFiltersList(token));
        dispatch(getMinistryList(token));
    }, [dispatch, token, loginId]);

    useEffect(() => {
        if (
            gemFilterData.ministryId === "" &&
            ministrylist &&
            ministrylist.length > 0
        ) {
            const data = ministrylist.find(
                (e) => e.ministry === "Ministry of Defence"
            );

            if (data) {
                setGemFilterData({
                    ministryId: data.id,
                    organizationId: "",
                });
            }
        }
    }, [ministrylist]);

    useEffect(() => {
        if (gemFilterData.ministryId) {
            dispatch(getOrganizationList(gemFilterData.ministryId, token));
        }
    }, [gemFilterData.ministryId]);

    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },
        {
            name: "Ministry",
            selector: (row) => row?.ministry || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Organization",
            selector: (row) => row?.organization || "-",
            sortable: true,
            align: "center",
        },
    ];

    const clearLeaveInputFields = () => {
        if (
            ministrylist &&
            ministrylist.length > 0
        ) {
            const data = ministrylist.find(
                (e) => e.ministry === "Ministry of Defence"
            );

            if (data) {
                setGemFilterData({
                    ministryId: data.id,
                    organizationId: "",
                });
            }
        }
    };

    const handleClose = () => {
        clearLeaveInputFields();
        setShow(false);
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setGemFilterData((prevData) => {
            let updatedData = {
                ...prevData,
                [id]: value,
            };
            return updatedData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!gemFilterData.ministryId || !gemFilterData.organizationId) {
            Swal.fire({
                icon: "warning",
                title: "Warning",
                text: "Please fill all the required fields.",
                timer: 2000,
            });
            return;
        }

        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(insertFilter(gemFilterData, token))
                .then((response) => {
                    if (response.statusCode === "00") {
                        dispatch(getGemEnableFiltersList(token));
                        setShow(false);
                        clearLeaveInputFields();
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.error,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "There was an error inserting  the gem filter details.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
        }
    };

    const ministryOptions = ministrylist.map(c => ({
        value: c.id,
        label: c.ministry,
    }));
    const organizationOptions = organizationlist
        .filter(
            (org) => !gemenalbefilterlist.some(
                (min) => min.organization === org.organization
            )
        ).map(c => ({
            value: c.id,
            label: c.organization,
        }));



    return (
        <div>
            <Navbar />

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="card3">
                        <div className="card-body">
                            <NewDataTable
                                columns={columns}
                                data={gemenalbefilterlist || []}
                                tableName="GeM FILTERS"
                                totalRecord={gemenalbefilterlist?.length ?? 0}
                            />
                            <div className="text-center">
                                <button
                                    type="button"
                                    className="btn btn-primary fw-bold mt-3"
                                    onClick={() => setShow(true)}
                                >
                                    ADD
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal leave-modal ${show ? "d-block" : "d-none"}`}
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add GeM Filters</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleClose}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                {/* Row 1: Leave Type, Start Date, End Date */}
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="leaveCode" className="form-label">
                                            Ministry <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            options={ministryOptions}
                                            value={ministryOptions.find(opt => opt.value === gemFilterData.ministryId) || null}
                                            onChange={(selectedOption) =>
                                                setGemFilterData(prev => ({
                                                    ...prev,
                                                    ministryId: selectedOption?.value || ""
                                                }))
                                            }
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="leaveCode" className="form-label">
                                            Organization <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            options={organizationOptions}
                                            value={organizationOptions.find(opt => opt.value === gemFilterData.organizationId) || null}
                                            onChange={(selectedOption) =>
                                                setGemFilterData(prev => ({
                                                    ...prev,
                                                    organizationId: selectedOption?.value || ""
                                                }))
                                            }
                                        />
                                    </div>

                                </div>
                                <div className="text-center">
                                    <button type="submit" className="btn btn-success mt-3">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

};

export default GemEnableFilter;
